/**
 * WordPress Dependencies
 */
import { useBlockProps, useInnerBlocksProps, BlockControls } from '@wordpress/block-editor';
import { ToolbarButton, ToolbarGroup } from '@wordpress/components';
import { createBlock } from '@wordpress/blocks';
import { dispatch, select } from '@wordpress/data';
import { Fragment, useEffect } from '@wordpress/element';
import { __ } from '@wordpress/i18n';

/**
 * External Dependencies
 */
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import { handleUniqueId } from '../../helper';
import Inspector from './inspector';
import DynamicStyle from './dynamic-style';

const Edit = props => {
    const { attributes, setAttributes, clientId, isSelected } = props;
    const { uniqueId } = attributes;

    useEffect(() => {
        handleUniqueId({ uniqueId, setAttributes, clientId });
    }, [uniqueId, setAttributes, clientId]);

    const blockProps = useBlockProps({
        className: classNames('wp-block-faqmate-accordions', uniqueId)
    });

    const innerBlockProps = useInnerBlocksProps(
        {
            className: 'faqmate-accordions-wrapper'
        },
        {
            allowedBlocks: ['faqmate/accordion'],
            template: [
                ['faqmate/accordion', { title: __('Accordion Item 1', 'faqmate-blocks') }],
                ['faqmate/accordion', { title: __('Accordion Item 2', 'faqmate-blocks') }]
            ],
            renderAppender: false,
            templateLock: false
        }
    );

    const addAccordion = () => {
        const childBlocks = select('core/block-editor').getBlocks(clientId);
        const newBlock = createBlock('faqmate/accordion', {
            title: __('New Accordion Item', 'faqmate-blocks')
        });
        dispatch('core/block-editor').insertBlock(newBlock, childBlocks.length, clientId);
    };

    return (
        <Fragment>
            {isSelected && <Inspector {...props} />}
            <DynamicStyle {...props} />

            <BlockControls>
                <ToolbarGroup>
                    <ToolbarButton icon="insert" label={__('Add Accordion', 'faqmate-blocks')} onClick={addAccordion} />
                </ToolbarGroup>
            </BlockControls>

            <div {...blockProps}>
                <div {...innerBlockProps} />
            </div>
        </Fragment>
    );
};

export default Edit;
